window.GoldNSwiperLoader = window.GoldNSwiperLoader || (function () {
  let loadPromise;

  function load() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-goldn-swiper-bundle="true"]');
      if (existing) {
        existing.addEventListener('load', () => resolve(window.Swiper), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.async = true;
      script.dataset.goldnSwiperBundle = 'true';
      script.onload = () => resolve(window.Swiper);
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return loadPromise;
  }

  return { load };
})();
